var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('Table'),_c('Pagination'),_c('dataDialog'),_c('detailDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }